import React, {Fragment} from 'react'
import { Icon } from '@driftt/tide-icons'

import './style.css'

const NotificationModal = ({
  showModal,
  toggle,
  changeSetToggle,
  text
}) => {
  const modal = toggle ? showModal : false
  return (
    <Fragment>
      {modal &&
        <div className="notification-modal fadeInDown">
          {text}
          <span onClick={changeSetToggle}><Icon name="close" className="notification-modal-close"/></span>
        </div>
      }
    </Fragment>
  )
}

export default NotificationModal